import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import ExistingFlow from './ExistingFlow';
import NewFlow from './NewFlow';
import ProjectSnapshot from './ProjectSnapshot';
import EmployeeUtilization from './EmployeeUtilization';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* The root URL now loads the Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* The separate dashboard routes */}
        <Route path="/existing-flow" element={<ExistingFlow />} />
        <Route path="/new-flow" element={<NewFlow />} />
        <Route path="/project-snapshot" element={<ProjectSnapshot />} />
        <Route path="/employee-utilization" element={<EmployeeUtilization />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
